export default function LoadingTable() {
  return (
    <table className="animate-pulse p-6 w-full">
      <tbody>
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
          <tr
            key={num}
            className={`border-b ${
              num === 0 ? "bg-neutralColor-light" : "bg-white"
            }`}
          >
            <td className="p-6">
              <span className="h-2 rounded-md bg-neutralColor-light w-48 block"></span>
            </td>
            <td>
              <span className="h-2 rounded-md bg-neutralColor-light w-32 block"></span>
            </td>
            <td>
              <span className="h-2 rounded-md bg-neutralColor-light w-32 block"></span>
            </td>
            <td>
              <span className="h-2 rounded-md bg-neutralColor-light w-32 block"></span>
            </td>
            <td>
              <span className="h-2 rounded-md bg-neutralColor-light w-32 block"></span>
            </td>
            <td>
              <span className="h-2 rounded-md bg-neutralColor-light w-32 block"></span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
